import React from 'react';
import { Snackbar, Alert } from '@mui/material';

export default function FloatingSnackbar({
    open,
    message,
    severity = 'info',
    onClose,
    autoHideDuration = 5000,
    anchor = { vertical: 'bottom', horizontal: 'left' }, // RTL bottom-right
    variant = 'filled'
}) {
    return (
        <Snackbar
            anchorOrigin={anchor}
            open={Boolean(open && message)}
            autoHideDuration={autoHideDuration}
            onClose={onClose}
        >
            <Alert onClose={onClose} severity={severity} variant={variant} sx={{ width: '100%' }}>
                {message}
            </Alert>
        </Snackbar>
    );
}


